module.exports = __webpack_public_path__ + "img/AT0000002448304.01f610ee.png";